<template>
  <!--
    @name: 自定义视频播放器
    @description: 视频播放器，aliplayer https://help.aliyun.com/document_detail/125570.html?spm=a2c4g.11186623.6.1089.46a66b05vZLyxd#h2-u5982u4F55u5BFCu51654
    @author:  GaoYu
    @time: 2020/7/1 10:50
  -->
  <div class="video-container">
    <div v-show="hasOverlay" class="overlay-container">
      <div class="overlay-box">试看结束，打开APP观看完整视频</div>
    </div>
    <div v-if="!hasOverlay" class="player-video-container" id="J_playerContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'MyVideo',
  data () {
    return {
      player: '',
      defaultOptions: {
        id: 'J_playerContainer',
        useH5Prism: true,
        autoplay: true,
        rePlay: true,
        controlBarVisibility: 'hover',
        height: '100%',
        x5_fullscreen: false,
        source: '',
        isLive: false,

        playsinline: true,
        extraInfo: {
          'x5-playsinline': 'true',
          'webkit-playsinline': 'true',
          'playsinline': 'true',
          'x-webkit-airplay': 'true',
          'preload': 'auto'
        }
      },
      playTimer: undefined,
      maxPlaySecond: 300,
      hasOverlay: false
    }
  },
  beforeDestroy () {
    this.destroyPlayer()
    this.playTimer && clearTimeout(this.playTimer)
    this.statusTimer && clearTimeout(this.statusTimer)
  },
  destroyed () {
    this.$off()
    this.$destroy()
  },
  methods: {
    destroyPlayer () {
      if (this.player && this.player.dispose !== undefined && this.player.dispose !== null) {
        this.player.dispose()
      }
    },
    createPlayer (options) {
      this.destroyPlayer()
      // 组件
      if (options.components === undefined || options.components.length === 0) {
        options.components = []
      }
      if (options.isRate) {
        options.components.push({name: 'RateComponent', type: AliPlayerComponent.RateComponent})
      }
      // skinLayout
      options.skinLayout = [
        {name: 'bigPlayButton', align: 'cc'},
        {name: 'H5Loading', align: 'cc'},
        {name: 'infoDisplay'},
        {name: 'tooltip', align: 'blabs', x: 0, y: 56},
        {name: 'thumbnail'}
      ]
      let controlBar = [
        {name: 'playButton', align: 'tl', x: 15, y: 12},
        {name: 'fullScreenButton', align: 'tr', x: 10, y: 12},
        {name: 'volume', align: 'tr', x: 5, y: 10}
      ]
      if (!options.isLive) {
        controlBar.push({name: 'timeDisplay', align: 'tl', x: 10, y: 5})
      }
      // delete options.isLive
      if (options.isProcess) {
        controlBar.push({name: 'progress', align: 'blabs', x: 0, y: 44})
      }
      options.skinLayout.push({name: 'controlBar', align: 'blabs', x: 0, y: 0, children: controlBar})

      let opt = Object.assign(this.defaultOptions, options)
      this.player = new Aliplayer(opt, function (player) {
        player.play()
        opt.videoType = parseInt(opt.videoType, 10)

        // 流中断
        player.on('liveStreamStop', () => {
          console.log('直播失败或直播已结束')
        })
        // 出错
        player.on('error', () => {
          console.log('出错了')
        })
      })

      this.playTimer = setInterval(() => {
        if (!this.player) {
          return false
        }
        // 不在直播，而且付费的
        if (!opt.isLive && opt.videoType === 2) {
          // 当前的播放时刻
          const playCurrentTime = Math.ceil(this.player.getCurrentTime())
          if (playCurrentTime > this.maxPlaySecond) {
            this.hasOverlay = true
            this.player.pause()
          }
        }
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
  .video-container {
    position: relative;
    width: 100%;
    height: 100%;
    .player-video-container {
      width: 100%;
      height: 100%;
      background: none;
    }
    /deep/ .prism-controlbar-bg {
      background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.5)) !important;
    }
    .overlay-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 9999999;
      .overlay-box {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 286px;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Common/MyVideo.vue